import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/gridsConfirmationModalType";
import deltas from "../../actions/deltas";

const {SET_GRIDS_CONFIRMATION_MODAL_TYPE_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.APPLY_COHORT, SET_GRIDS_CONFIRMATION_MODAL_TYPE_STATE);
